import io from 'socket.io-client'
import { cookies, logoutCookies } from '@/utils/cookies'
import router from '../router/index'
import socketUrl from '../../src/assets/js/libs/Socket'
import API from '../assets/js/libs/API'
import Record_behavir from '../assets/js/libs/FirebaseAPI/RecordBill'
var record = new Record_behavir()

export default {
  data() {
    return {
      socket: null,
    }
  },
  methods: {
    _socketConnection(event) {
      if (this.socket) {
        this.checkTokenExpired()
        return
      }
      this.socket = io(socketUrl, {
        query: {
          token: cookies.get('user'),
          event: event,
        },
        transports: ['websocket'],
      })
      this.initOnConnectHandler()
      this.initOnTimeoutHandler()
      this.initOnDisconnectHandler()
      this.initOnSubmitOrderHandler()
      this.initOnGetOrderIdHandler()
      this.initOnLineUpOrderNotifyHandler()
      this.$refs.hailResultModal.deliverySocket(this.socket)
      this.checkTokenExpired()
    },
    checkTokenExpired() {
      this.socket.on('TokenValidError', (data) => {
        if (!data.success) {
          logoutCookies()
          this._closeSocket()
        }
      })
    },
    initOnConnectHandler() {
      cookies.set('socketConnectState', null)
      this.socket.on('connect', () => {
        console.log('socket connect')
        this.socket.sendBuffer = []
        this.$refs.hailResultModal.setConnectionState(true)
        cookies.set('socketConnectState', true)
      })
      this.socket.on('error', (e) => {
        console.log('socket error: ', e)
        this._closeSocket()
      })
      this.socket.on('connect_error', (e) => {
        console.log('socket connect error: ', e)
        this._closeSocket()
      })
    },
    initOnTimeoutHandler() {
      this.socket.on('connect_timeout', (timeout) => {
        console.log(timeout)
      })
    },
    initOnDisconnectHandler() {
      this.socket.on('disconnect', () => {
        this.$refs.hailResultModal.setConnectionState(false)
      })
    },
    initOnSubmitOrderHandler() {
      this.socket.on('SubmitOrder', (msg) => {
        this.hasSendCar = false
        if (this.vehicles !== 1) {
          if (
            msg.result !== '無車輛可派。' &&
            this.orderIDArray.indexOf(msg.result.orderID) !== -1
          ) {
            let recordInfo = {}
            recordInfo.type = '立即單'
            recordInfo.event = '回傳立即單'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = msg.result.orderID
            recordInfo.note = '多輛車'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            this.$refs.hailResultModal.hailingTaxiResult(msg)
          }
          if (this.orderIDArray.indexOf(msg.orderId) !== -1) {
            this.$refs.hailResultModal.hailingTaxiResult(msg)
          }
          return
        }
        console.log('msg.result.orderID', msg)
        if (
          msg.result !== '無車輛可派。' &&
          msg.result.orderID === this.orderIDArray[0]
        ) {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '回傳立即單'
          recordInfo.code = cookies.get('GladTeamCode')
          recordInfo.id = msg.result.orderID
          recordInfo.note = '單一'
          recordInfo.user_name = cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          this.$refs.hailResultModal.hailingTaxiResult(msg)
          return
        }
        if (msg.orderId === this.orderIDArray[0]) {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '回傳立即單'
          recordInfo.code = cookies.get('GladTeamCode')
          recordInfo.id = msg.orderId
          recordInfo.note = '單一，無車輛可派'
          recordInfo.user_name = cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          this.$refs.hailResultModal.hailingTaxiResult(msg)
        }
      })
    },
    initOnGetOrderIdHandler() {
      this.socket.on('GetOrderId', (msg) => {
        this.createRecordDriverAbnormalList(msg.result)
        this.orderIDArray.push(msg.result)
        this.isServerCheckReceiveOrder = true
        if (this.amountOfCounter === 0) {
          this.$refs.hailResultModal.startCountTime(true)
          this.amountOfCounter = 1
        }
      })
    },
    initOnLineUpOrderNotifyHandler() {
      this.socket.on('LineUpOrderNotify', (msg) => {
        console.log('line up order notify msg', msg)
        this.$refs.hailResultModal.stopCountShiftTime()
        if (cookies.get('GladTeamCode') === '888') {
          this.$msg(`呼號/編號:${msg.callNumber}，司機已看到訂單並按確認`)
        } else {
          alert(`呼號/編號:${msg.callNumber}，司機已看到訂單並按確認`)
        }
      })
    },
    _closeSocket() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    },
    createRecordDriverAbnormalList(id) {
      let payload = {
        id,
        type: 'transaction',
      }
      API.post('bill/driver/abnormal', payload).catch(() => {
        this.$msg('網路不穩定,產生異常表失敗')
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/socket.js